import PropTypes from 'prop-types';
import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
} from "reactstrap";
import { Link } from "react-router-dom";


// import images
import servicesIcon1 from "../../assets/images/services-icon/01.png";
import servicesIcon2 from "../../assets/images/services-icon/02.png";
import servicesIcon3 from "../../assets/images/services-icon/03.png";
import servicesIcon4 from "../../assets/images/services-icon/04.png";
import ChatBot from 'pages/ChatBot';
import IndustryOverview1 from './IndustryOverview1';
import ObservedInd1 from './ObservedInd1';
import IndustManfact1 from './IndustManfact1';
import IndusBenchMark1 from 'pages/AllCharts1/echart1/IndusBenchMark1';
import BusisnessRisk1 from 'pages/AllCharts1/apex1/BusisnessRisk1';
import FinancialRisk1 from 'pages/AllCharts1/apex1/FinancialRisk1';
import IndustryRisk1 from 'pages/AllCharts1/apex1/IndustryRisk1';
import OverAllRisk1 from 'pages/AllCharts1/apex1/OverAllRisk1';


const Dashboards = props => {
  const [menu, setMenu] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const toggle = () => {
    setMenu(!menu);
  };
  document.title = "Dashboards | Bvo - Dashboards";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={8}>
                <h6 className="page-title">Dashboards</h6>
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item active">Welcome to Bvo Dashboards</li>
                </ol>
              </Col>


            </Row>
          </div>
          <Row>
            <Col xl={3} md={6}>
              <Card className="mini-stat bg-primary text-white">
                <CardBody>
                  <div className="mb-4">
                    <div className="float-start mini-stat-img me-4">
                      <img src={servicesIcon1} alt="" />
                    </div>
                    <h5 className="font-size-16 text-uppercase mt-0 text-white-50">
                      Entity Valuation
                    </h5>
                    <h4 className="fw-medium font-size-24">
                      $2,640,822.87
                      <i className="mdi mdi-arrow-up text-success ms-2"></i>
                    </h4>
                    <div className="mini-stat-label bg-success">
                      <p className="mb-0">+ 12%</p>
                    </div>
                  </div>
                  <div className="pt-2">
                    <div className="float-end">
                      <Link to="#" className="text-white-50">
                        <i className="mdi mdi-arrow-right h5"></i>
                      </Link>
                    </div>
                    <p className="text-white-50 mb-0 mt-1">Since last month</p>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col xl={3} md={6}>
              <Card className="mini-stat bg-primary text-white">
                <CardBody>
                  <div className="mb-4">
                    <div className="float-start mini-stat-img me-4">
                      <img src={servicesIcon2} alt="" />
                    </div>
                    <h5 className="font-size-16 text-uppercase mt-0 text-white-50">
                    Total Assets
                    </h5>
                    <h4 className="fw-medium font-size-24">
                      $879,892.05
                      <i className="mdi mdi-arrow-down text-danger ms-2"></i>
                    </h4>
                    <div className="mini-stat-label bg-danger">
                      <p className="mb-0">- 28%</p>
                    </div>
                  </div>
                  <div className="pt-2">
                    <div className="float-end">
                      <Link to="#" className="text-white-50">
                        <i className="mdi mdi-arrow-right h5"></i>
                      </Link>
                    </div>

                    <p className="text-white-50 mb-0 mt-1">Since last month</p>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col xl={3} md={6}>
              <Card className="mini-stat bg-primary text-white">
                <CardBody>
                  <div className="mb-4">
                    <div className="float-start mini-stat-img me-4">
                      <img src={servicesIcon3} alt="" />
                    </div>
                    <h5 className="font-size-16 text-uppercase mt-0 text-white-50">
                      Earnings based valuations
                    </h5>
                    <h4 className="fw-medium font-size-24">
                      $1,942,511.77
                      <i className="mdi mdi-arrow-up text-success ms-2"></i>
                    </h4>
                    <div className="mini-stat-label bg-info">
                      <p className="mb-0"> 00%</p>
                    </div>
                  </div>
                  <div className="pt-2">
                    <div className="float-end">
                      <Link to="#" className="text-white-50">
                        <i className="mdi mdi-arrow-right h5"></i>
                      </Link>
                    </div>

                    <p className="text-white-50 mb-0 mt-1">Since last month</p>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col xl={3} md={6}>
              <Card className="mini-stat bg-primary text-white">
                <CardBody>
                  <div className="mb-4">
                    <div className="float-start mini-stat-img me-4">
                      <img src={servicesIcon4} alt="" />
                    </div>
                    <h5 className="font-size-16 text-uppercase mt-0 text-white-50">
                      Your Recommended Multiple
                    </h5>
                    <h4 className="fw-medium font-size-24">
                      2.51
                      <i className="mdi mdi-arrow-up text-success ms-2"></i>
                    </h4>
                    {/* <div className="mini-stat-label bg-warning">
                      <p className="mb-0">+ 84%</p>
                    </div> */}
                  </div>
                  <div className="pt-2">
                    <div className="float-end">
                      <Link to="#" className="text-white-50">
                        <i className="mdi mdi-arrow-right h5"></i>
                      </Link>
                    </div>
                    <p className="text-white-50 mb-0 mt-1">Since last month</p>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>


          <Row>
            <Col xl={3}>
              <BusisnessRisk1/>
            </Col>
            <Col xl={3}>
              <FinancialRisk1/>
            </Col>
            <Col xl={3}>
              <IndustryRisk1/>
            </Col>
            <Col xl={3}>
            <OverAllRisk1/>
            </Col>
          </Row>

   

          <ChatBot />
        </Container>
      </div>

    </React.Fragment>
  );
};

Dashboards.propTypes = {
  t: PropTypes.any
};

// export default withTranslation()(Dashboards);
export default Dashboards;
